@if (profileField$ | async; as profileField) {
  @for (typedValue of typedLabeledValues$ | async; track typedValue) {
    @if (typedValue.value.length > 0) {
      <dt class="sh-description-list__term" [id]="profileField.FieldDefinition.DottedKey + '.' + typedValue.type">
        <sh-field-label [label]="typeTranslations.get(typedValue.type)" [labelIcons]="labelIcons"></sh-field-label>
      </dt>
      @if (typeFieldDefinitions.get(typedValue.type); as typeFieldDef) {
        <dd class="sh-description-list__details">
          <ng-container
                    *ngTemplateOutlet="
                        canSearchOnClick(typeFieldDef) ? searchableData : nonSearchableData;
                        context: { values: typedValue.value, fieldDefinition: typeFieldDef }
                    "
            >
          </ng-container>
        </dd>
      }
    }
  }
}

<ng-template #searchableData let-values="values" let-fieldDefinition="fieldDefinition">
  @for (labeledValue of values; track labeledValue; let index = $index) {
    <span>
      <a class="sh-link" [routerLink]="searchRouterLink" [queryParams]="getSearchRouterParams(fieldDefinition, labeledValue.value)">{{
        labeledValue.label
      }}</a>
      @if (index < values.length - 1) {
        ,
      }
    </span>
  }
</ng-template>

<ng-template #nonSearchableData let-values="values">
  @for (labeledValue of values; track labeledValue; let index = $index) {
    <span>
      {{ labeledValue.label }}
      @if (index < values.length - 1) {
        ,
      }
    </span>
  }
</ng-template>
